module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QjR7db/tc-custom/9781460317570.jpg?1705766051071",
      "alt": "This image is the cover for the book Dance with the Rancher, Undone!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dance with the Rancher, Undone!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Colorado, 1879"), _c('i', [_c('br'), _c('br'), _vm._v("Jilted once, Garret McCoy has sworn never to fall in love again. But that doesn’t stop him from wanting to have a little fun, and he bets he can be the man to get the preacher’s shy daughter out on the dance floor. He never gambled on her stealing his heart, though!"), _c('br'), _c('br'), _vm._v("Rory Boyle has kept to herself, fearful if the townsfolk learn her secret, she’ll be an outcast. But she can’t resist taking a turn with the handsome but ornery Garret. Or giving in to his kisses")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lauri Robinson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Lauri Robinson lives in Minnesota where she and her husband spend every spare moment with their three grown sons and their families—spoiling the grandchildren. She’s a member of Romance Writers of America and Northern Lights Writers. Along with volunteering for several organizations, she is a diehard Elvis and NASCAR fan. Her favorite getaway location is along the Canadian Border of Northern Minnesota on the land homesteaded by her great-grandfather.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0